<!-- 
PROPS:
- Preguntas -> Se pasa un objecto con el siguiente formato:
  - enunciado -> Texto
  - opciones -> Arreglode texto con opciones
  - respuesta -> respuesta correcta usando la posición de la respuesta en el arreglo
  - retroalimentacionBien -> Texto de retroalimentación cuando responde bien
  - retroalimentacionMal  -> Texto de retroalimentación cuando responde mal
-->
<template>
    <v-layout align-center fill-height justify-center row wrap>
        <!-- Íconos de preguntas  -->
        <v-flex :key="index" class="text-xs-center icono-pregunta" v-for="(pregunta,index) in preguntas" xs6>
            <img :alt="'pregunta '+index" :src="icons[index]"
                 @click="abrirModal(index)" class="animated fadeIn hvr hvr-scale actividad-img" v-if="preguntasContestadas >= index">
            <img :src="correctas[index]? imgBienBot: imgMalBot" class="retroalim-bot"
                 v-if="preguntasContestadas > index">
        </v-flex>
        <v-layout>
            <v-dialog v-model="modal" width="500px">
                <v-card>
                    <boton-cerrar-modal-app :titulo="'Pregunta '+(actual+1)"
                                            @cerrar="modal=false"></boton-cerrar-modal-app>
                    <v-card-text>
                        <p>{{preguntas[actual].enunciado}}</p>
                        <div class="text-xs-center" v-if="imagenes">
                            <img :src="imagenes[actual]" alt="">
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-layout justify-center row wrap>
                            <v-flex :id="'opcion'+index" :key="'opcion'+index"
                                    @click="validarRespuesta(index)" class="hvr hvr-color ma-1 opcion"
                                    v-for="(opcion,index) in preguntas[actual].opciones" xs12>
                                <p class="pa-1">{{opcion}}</p>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                    <v-card-text :class="retroalimClass" class="text-xs-center animated fadeIn" v-if="retroalim">
                        {{retroalimText}}
                        <v-btn @click="reintentar()" v-if="reintentarBoton">Reintentar</v-btn>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-layout>
</template>
<script>


    export default {

        props: ['preguntas', 'imagenes'],
        data() {
            return {
                actual: 0,
                mostrarImagen: false, //Si la pregunta está basada en una imagen, muestra la imagen
                retroalim: false,
                retroalimText: '',
                retroalimClass: '', // bien o mal
                modal: false,
                cerrar: '',
                icons: [],
                correctas: [],
                imgBienBot: '',
                imgMalBot: '',
                reintentarBoton: false,
                preguntasContestadas: 0 //Contador
            }
        },
        created() {
            var self = this
            this.getPng('imagenes_compartidas/cerrar_blan', data => {
                self.cerrar = data
            })
            this.getPng('imagenes_compartidas/ok-bot', data => {
                self.imgBienBot = data
            })
            this.getPng('imagenes_compartidas/mal-bot', data => {
                self.imgMalBot = data
            })
            for (var i = 1; i <= this.preguntas.length; i++) {
                this.getPng('imagenes_compartidas/actividad' + i, data => {
                    self.icons.push(data)
                })
            }
            this.correctas = Array(this.preguntas.length).fill(false)
        },
        methods: {
            validarRespuesta(resp) {
                // Ocultar todas las opciones excepto la seleccionadas
                var opciones = Array.from(document.querySelectorAll('.opcion'))
                opciones.forEach(element => {
                    if (element.id != "opcion" + resp) {
                        element.style.display = 'none'
                    }
                });
                // Validar y agregar retroalimentación
                if (resp == this.preguntas[this.actual].respuesta) {
                    this.retroalimText = this.preguntas[this.actual].retroalimentacionBien
                    this.retroalimClass = 'bien'
                    this.correctas[this.actual] = true
                    this.reintentarBoton = false
                    // Solo avanza hasta que reponda bien la pregunta actual (la condición es para prevenir que no avance si responde la misma pregunta varias veces)
                    if (this.preguntasContestadas <= this.actual)
                        this.preguntasContestadas++
                } else {
                    this.retroalimText = this.preguntas[this.actual].retroalimentacionMal
                    this.retroalimClass = 'mal'
                    this.reintentarBoton = true
                }
                this.retroalim = true;
                if (this.preguntasContestadas >= this.preguntas.length) {
                    this.$emit('actividadFinalizada')
                }
            },
            reintentar() {
                // Devolver visibilidad a las opciones
                var opciones = Array.from(document.querySelectorAll('.opcion'))
                opciones.forEach(element => {
                    element.style.display = ''
                });

                // Remover retroalimentación
                this.retroalim = false;
            },
            abrirModal(id) {
                this.modal = true;
                this.actual = id
                this.retroalimClass = ''
                this.retroalim = false;
                this.reintentar()
            }
        }
    }
</script>
<style lang="scss" scoped>
    .bien {
        background-color: #BEF299;
    }

    .mal {
        background-color: #FFA1A1;
    }

    .cerrar {
        padding: 10px;
        padding-bottom: 0;

        img {
            width: 30px;
            padding: 5px;
            background: #004636;
            border-radius: 45px;
        }
    }

    .actividad-img {
        max-width: 50%;
        height: 15vh;
    }

    .icono-pregunta {
        position: relative;
    }

    .retroalim-bot {
        position: absolute;
        top: 0;
        left: calc(50% - 15px);
    }

    .opcion {
        border-radius: 5px;
    }
</style>

